@if (useCoreComponentsAccordion) {
    <core-accordion-group
        [multiExpandable]="true"
        iconOpen="chevron-up"
        iconClosed="chevron-down"
        [iconSize]="[16, 16]"
        [style.--accordion-title-bg-color]="accordionTheme?.titleBgColor || null"
        [style.--accordion-title-border-color]="accordionTheme?.titleBorderColor || null"
        [style.--accordion-title-open-border-color]="accordionTheme?.titleOpenBorderColor || null"
        [style.--accordion-title-open-bg-color]="accordionTheme?.titleOpenBgColor || null"
        [style.--accordion-title-hover-bg-color]="accordionTheme?.titleOpenBgColor || null"
        [style.--accordion-title-hover-border-color]="accordionTheme?.titleOpenBorderColor || null"
        [style.--accordion-body-border-color]="accordionTheme?.titleOpenBorderColor || null">
        @for (accordionItem of block.content; track accordionItem) {
            <core-accordion-item [title]="accordionItem.data.title">
                @for (subBlock of accordionItem.content; track subBlock) {
                    <core-block [block]="subBlock" class="subWidget {{ subBlock.data.class }}"></core-block>
                }
            </core-accordion-item>
        }
    </core-accordion-group>
} @else {
    <mat-accordion>
        @for (item of block.content; track item; let i = $index) {
            @if (item.data.title) {
                <mat-expansion-panel
                    [expanded]="panelStates[i]"
                    (opened)="onPanelOpened(i)"
                    (closed)="setState(i, false)"
                    #panel>
                    <mat-expansion-panel-header
                        [collapsedHeight]="'auto'"
                        [expandedHeight]="'auto'"
                        [core-analytics]="{ action: [getPanelState(i), item.data.title].join(':'), block }">
                        <mat-panel-title [innerHTML]="item.data.title" [attr.id]="item.data.anchorId"></mat-panel-title>
                    </mat-expansion-panel-header>
                    <div
                        class="{{ block.data.title }} {{ block.data.visibility }}"
                        [ngClass]="{
                            container: block.data.columnsSmall === 'full' || block.data.columnsNormal === 'full',
                            'col-sm-12': block.data.columnsSmall === 'full',
                            'col-md-12': block.data.columnsNormal === 'full',
                        }"
                        [ngStyle]="{ padding: block.data.padding, margin: block.data.margin }">
                        @for (subBlock of item.content; track subBlock) {
                            <core-block [block]="subBlock" class="subWidget {{ subBlock.data.class }}"></core-block>
                        }
                    </div>
                </mat-expansion-panel>
            }
        }
    </mat-accordion>
}
